<p>GeoAI uses site scheme to provide an exact location of
    each panel and issues related to each panel.</p>
<br />
<div class="container-fluid">

    <div class="row">
        <div class="col">
            <h4><i class="fas fa-solar-panel"></i> Locator</h4>
            <p>Please, enter panel locator configuration</p>
        </div>
    </div>
    <div class="row">
        <div class="col-5">
            <table class="table table-hover table-striped frms-table table-locator">
                <thead>
                    <tr class="row-title">

                        <td class="col-title">Level Order </td>
                        <td class="col-title">Description </td>
                    </tr>
                </thead>

                <ng-container *ngFor="let control of locatorEdit ;let idx=index">
                    <tr class="row-title">

                        <td class="col-title">{{control.key}} </td>
                        <td>
                            <input [(ngModel)]="control.value" class="form-control form-control-sm locator-input">

                        </td>
                    </tr>
                </ng-container>
            </table>


            <div class="locator-buttons">
                <button *permusr="{id:controlEnum.BTN_SITE_EDIT, authFunction:ui_showbtn(controlEnum.BTN_SITE_EDIT)}"
                    matTooltip="Add locator field" type="button" class="btn btn-sm  btn-outline-primary "
                    (click)="addLocator()">
                    <i class="far fa-plus-square"></i>
                </button>
                <button *permusr="{id:controlEnum.BTN_SITE_EDIT, authFunction:ui_showbtn(controlEnum.BTN_SITE_EDIT)}"
                    matTooltip="Remove last locator field" type="button" class="btn btn-sm  btn-outline-primary "
                    (click)="removeLastLocator()">
                    <i class="far fa-minus-square"></i>
                </button>
            </div>


        </div>
        <div class="col-7">
            <h4>Locator format</h4>
            <p>Please enter the formatter for the name of each panel. </p>
            <input [(ngModel)]="locatorFormat" class="form-control locator-input-formater">
            <div class="block-help">
                <p>
                    The system will replace each key (L1 L2 and so on) in the name of the panel.
                </p>
                <p>For example, for panel:L1=Z2 L2=3 L3=4 </p>
                <ul>
                    <li><code>{{"{L1}.Row{L2}-Col{L3}"}}</code> will be Z2.Row3-Col4</li>
                    <li><code>{{"{L1}.{L2}-{L3}"}}</code> will be Z2.3-4</li>
                    <li><code>{{"Area-{L1}.{L2}-{L3}"}}</code> will be Area-Z2.3-4</li>
                </ul>
            </div>

        </div>
    </div>
    <br />

    <div class="row">
        <div class="col">
            <h4><i class="fas fa-table"></i> Reports</h4>
            <p>Please, enter column name and locator field to show in reports. Order columns as you wish.
                Locator fields can use regular expressions too. Enter the locator between {{"{} for example:{L1} or
                C{L3}"}} </p>
        </div>
    </div>
    <div class="row">
        <div class="col-5">
            <div class="report-config" cdkDropList [cdkDropListData]="report_locatorEdit"
                (cdkDropListDropped)="dropReport($event)">
                <div class="rep-row">
                    <div class="col-draghandle"></div>
                    <div class="col-title col-input">Column name </div>
                    <div class="col-title col-input">Locator fields </div>
                </div>
                <ng-container *ngFor="let control of report_locatorEdit ;let idx=index">
                    <div class="rep-row" cdkDrag [cdkDragData]="control">
                        <div class="col-draghandle draghandle">
                            <mat-icon cdkDragHandle>reorder</mat-icon>
                        </div>
                        <div class="col-input"><input [(ngModel)]="control.value"
                                class="form-control form-control-sm locator-input"></div>
                        <div class="col-input"><input [(ngModel)]="control.format"
                                class="form-control form-control-sm locator-input"> </div>
                    </div>
                </ng-container>
            </div>
            <div class="locator-buttons">
                <button *permusr="{id:controlEnum.BTN_SITE_EDIT, authFunction:ui_showbtn(controlEnum.BTN_SITE_EDIT)}"
                    matTooltip="Add locator field" type="button" class="btn btn-sm  btn-outline-primary "
                    (click)="addReportColumn()">
                    <i class="far fa-plus-square"></i>
                </button>
                <button *permusr="{id:controlEnum.BTN_SITE_EDIT, authFunction:ui_showbtn(controlEnum.BTN_SITE_EDIT)}"
                    matTooltip="Remove last locator field" type="button" class="btn btn-sm  btn-outline-primary "
                    (click)="removeReportColumn()">
                    <i class="far fa-minus-square"></i>
                </button>
            </div>

            <!--             <button type="button" class="btn btn-sm  btn-outline-primary " (click)="getConfig()">
                <i class="far fa-plus-square"></i> test
            </button> -->
        </div>
        <!--         <div class="col-7" cdkDropListGroup>
            <div class="report-config">
                <div cdkDropList [cdkDropListData]="locatorEdit" class="rep-row" id="cdk-drop-list-locators"
                    (cdkDropListDropped)="dropReportColumnField($event)" cdkDropListOrientation="horizontal">
                    <ul class="list-group list-group-horizontal report-column-locator-drop list-group-item-drop">
                        <li class="list-group-item" *ngFor="let control of locatorEdit ;let idx=index" cdkDrag>
                            {{control.value}}
                        </li>
                    </ul>                    
                </div>
                <ng-container *ngFor="let control of report_locatorEdit ;let idx=index">
                    <div class="rep-row no-flex report-row-drop-container">
                        <div cdkDropList [cdkDropListData]="control.fields" class="report-column-fields"
                            [attr.id]="'lst'+idx" (cdkDropListDropped)="dropReportColumnField($event)"
                            cdkDropListOrientation="horizontal">
                            <ul class="list-group list-group-horizontal list-group-item-drop">
                                <li class="list-group-item " *ngFor="let colfields of control.fields ;let li_idx=index"
                                    cdkDrag>
                                    {{colfields.value}}<input class="form-control form-control-sm locator-input" > </li>
                            </ul>
                            
                        </div>
                    </div>


                </ng-container>
            </div>
        </div> -->
    </div>



</div>